var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 17,
    viewBox: "0 0 6 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25473 5.66284C1.92172 5.66284 0.881684 4.6228 0.881684 3.28979C0.881684 1.97144 1.92172 0.916748 3.25473 0.916748C4.57309 0.916748 5.62778 1.97144 5.62778 3.28979C5.62778 4.6228 4.57309 5.66284 3.25473 5.66284ZM3.25473 16.0925C1.92172 16.0925 0.881684 15.0378 0.881684 13.7195C0.881684 12.3865 1.92172 11.3464 3.25473 11.3464C4.57309 11.3464 5.62778 12.3865 5.62778 13.7195C5.62778 15.0378 4.57309 16.0925 3.25473 16.0925Z",
    fill: "url(#paint0_linear_5143_19855)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5143_19855",
    x1: -2.38037,
    y1: 5.10655,
    x2: 8.88983,
    y2: 5.10655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D90000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005DB4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleDot);
export default __webpack_public_path__ + "static/media/doubleDot.bef673f78dc03fec5e1316285a93f67d.svg";
export { ForwardRef as ReactComponent };